import React, {Suspense, useEffect} from "react";
import useFetch, {CachePolicies, Provider} from "use-http";
import {Provider as ReduxProvider} from 'react-redux';
import {store} from './store';
import MainRoutes from "./routes";
import ProviderContext from "./pages/context/App.context";
import LogoLoading from "./pages/firstPage/LogoLoading";
import styles from "./pages/firstPage/UIFirstPage.module.scss";
import * as Auth from "./service/auth.service";
import {AuthKeys, getToken, resetToken} from "./service/auth.service";
import moment from "moment";
import {pathRoutes} from "./props/util.props";
import {UserAPIEndpoint} from "./service/user.service";
import ReactGA from 'react-ga4';
import "./App.css";
import {ConfigProvider, Button} from 'antd';
import Routes from "./routes";
// ReactGA.initialize('G-Y4LHLXRE03', send_page_view: false);
ReactGA.initialize([
    {
        trackingId: window.__RUNTIME_CONFIG__.REACT_APP_GA_MEASUREMENT_ID || "",
        // gaOptions: {
        //   send_page_view: false
        // }, // optional
        // gtagOptions: {...}, // optional
    },
]);
// ReactGA.pageview(window.location.pathname + window.location.search);

export default function App() {
    // useJanusPlugin();

    let systemStatus = 401;
    const options: any = {
        headers: {
            Accept: `application/json`,
            // "CenterContent-Type": `application/json`,
        },
        interceptors: {
            // every time we make an http request, this will run 1st before the request is made
            // url, path and route are supplied to the interceptor
            // request options can be modified and must be returned
            request: async ({
                                options,
                                url,
                                path,
                                route,
                            }: {
                options: any;
                url: string;
                path: string;
                route: any;
            }) => {
                let token = getToken();
                if (token) {
                    options.headers["Authorization"] = `Bearer ${token}`;
                }
                return options;
            },
            response: ({response}: { response: any }) => {
                let now = moment();
                let expireDate =
                    localStorage.getItem(AuthKeys.expiresDate) ||
                    sessionStorage.getItem(AuthKeys.expiresDate);
                let isExpired = moment(expireDate).diff(now) < 0;
                if (isExpired) {
                    resetToken(true);
                }
                if (
                    response?.status !== systemStatus &&
                    response?.url?.indexOf(window.__RUNTIME_CONFIG__.REACT_APP_CZ_URL) === -1
                ) {
                    systemStatus = response.status;
                    if (response.status === 401) {
                        // temporary change actual value is true.
                        resetToken(false);
                    }
                }
                return response;
            },
        },
    };

    // useEffect(() => {
    //     // initializeFirebase();
    //     // checkToken();
    // }, []);

    const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
        cachePolicy: CachePolicies.NO_CACHE,
    });

    // const checkToken = async () => {
    //     const me = await api.get(UserAPIEndpoint.Me);
    //     if (me?.status === "Unauthorized") {
    //         Auth.resetToken(false);
    //         navigate(pathRoutes.Root);
    //     }
    // };

    return (
        <ConfigProvider
            theme={{
                // inherit: false,
                token: {
                    //   colorPrimary: '#00b96b',
                    colorPrimaryBg: "#f0f2f5"
                },
            }}
        >
            <Provider url={""} options={options}>
                <ReduxProvider store={store}>
                    <Suspense
                        fallback={
                            <div
                                style={{
                                    height: "100vh",
                                    fontSize: "20px",
                                }}
                            >
                                <div className={styles.boxIcon} style={{width: "100%"}}>
                                    <div className={styles.boxIconCenter}>
                                        <LogoLoading/>
                                    </div>
                                </div>
                            </div>
                        }
                    >
                        <ProviderContext>
                            {/*<PostProviderContext>*/}
                            {/*<Router>*/}
                            <MainRoutes />
                            {/*    <MainRoutes/>*/}
                            {/*</Router>*/}
                            {/*</PostProviderContext>*/}
                        </ProviderContext>
                    </Suspense>
                </ReduxProvider>
            </Provider>
        </ConfigProvider>
    );
}
